import React from 'react';

import * as ManifestUI from '@project44/manifest-ds';

import { TFunctionComponent } from '../../../../../shared/core/infrastructrue/types';
import { TUserTenantAgnosticRolesSelectAllCheckbox } from '../../../domain/interfaces';
import { UserI18NPort } from '../../ports/User.i18n.port';

export const UserTenantAgnosticRolesSelectAllCheckbox: TFunctionComponent<
  TUserTenantAgnosticRolesSelectAllCheckbox
> = ({
  isApiRequestInProgress,
  handleAddAllRoles,
  handleRemoveAllRoles,
  isEditableByUserPrincipal,
  assignedUserTenantAgnosticRolesState,
}) => {
  const [
    assignedUserTenantAgnosticRoles,
    updateAssignedUserTenantAgnosticRoles,
  ] = assignedUserTenantAgnosticRolesState;

  const isAtLeastOneRoleSelected = () => {
    return Array.from(assignedUserTenantAgnosticRoles.values()).some(
      (value) => !!value,
    );
  };

  const isAllSelected = () => {
    return Array.from(assignedUserTenantAgnosticRoles.values()).every(
      (value) => !!value,
    );
  };

  return (
    <ManifestUI.Checkbox
      role={'checkbox'}
      aria-label={`select all tenant agnostic roles`}
      onChange={(isSelected) => {
        const handleToggleAllRoles = isSelected
          ? handleAddAllRoles
          : handleRemoveAllRoles;
        updateAssignedUserTenantAgnosticRoles(
          handleToggleAllRoles(assignedUserTenantAgnosticRoles),
        );
      }}
      isDisabled={!isEditableByUserPrincipal || isApiRequestInProgress}
      isSelected={isAllSelected()}
      isIndeterminate={isAtLeastOneRoleSelected() && !isAllSelected()}
    >
      <ManifestUI.Typography variant={'subtextBold'}>
        {UserI18NPort.scopedTranslator(
          'userTenantAgnosticRolesSelectAllCheckbox.grantAccessAllTenants',
        )}
      </ManifestUI.Typography>
    </ManifestUI.Checkbox>
  );
};
